// Webpack Imports
import 'bootstrap';

( function ( $ ) {
	'use strict';

    if ($(window).width() < 1420) {

$('.dropdown-toggle').click(function(e) {
        e.preventDefault();
        link.href = '';
    });
}

$('.dropdown > a').click(function(){
        location.href = this.href;
    });

$('a.demo:contains("Request free demo")').attr("data-toggle","modal").attr("data-target","#demo-modal");

// $('a.demo').each ( function() {
//     if($(this)contains( 'Request free demo' ) )
//     {
//         $(this).attr("data-toggle","modal");
//         $(this).attr("data-target","#demo-modal");
//     }
// });

$('a.demo:contains("Brochure")').attr("data-toggle","modal").attr("data-target","#download-modal");
$('a.demo:contains("Watch")').attr("data-toggle","modal").attr("data-target","#download-modal");

// $('a.demo').each ( function() {
//     if($(this)contains( 'Download' ) )
//     {
//         $(this).attr("data-toggle","modal");
//         $(this).attr("data-target","#download-modal");
//     }
// });

// clickable dropdown menu parent
  // $('.navbar .dropdown > a').on('click', function(e) {
  //   let elementBegin = $(this).offset()['left']; // get link position X

  //   // get the width of the menu by text's length
  //   // you need to contain the text inside a span tag
  //   let spanWidth = $(this).find("> span").width();
  //   let clickAreaLength = spanWidth * 0.9; // 90% of width = clickable area

  //   let clickPositionX = e.pageX; // position of the click

  //   // if click position is inside the clickable area, then redirect
  //   if (clickPositionX < elementBegin + clickAreaLength) {
  //     location.href = this.href;
  //   }
  // });

	// Focus Search if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );




// Lazy Load Images using Intersection Observer
(function () {
  var observer = new IntersectionObserver(onIntersect);

  document.querySelectorAll("[data-lazy]").forEach((img) => {
    observer.observe(img);
  });

  function onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.target.getAttribute("data-processed") || !entry.isIntersecting)
        return true;
      entry.target.setAttribute("src", entry.target.getAttribute("data-src"));
      entry.target.setAttribute("data-processed", true);
    });
  }
})();


  $(".date--container").html(function(index, html) {
      return html.replace(/\S/g, '<span>$&</span>');
    });

$("#load_more").click(function()
{
    $.post(ajaxurl,
    {
      'action': 'your_load_more',
      'count': $("#post--wrapper .post-wrap").length
    },
    function(response)
    {
      var posts = JSON.parse(response);

      for( var i = 0; i < posts.length; i++ )
      {
        if( posts[i] == "0" )
          $("#load_more").fadeOut();
        else
          $("#load_more").before(posts[i]);
      }

    });

});



  if( $("div").hasClass( "slideshow--wrapper-dark" ) )
  {
    $( ".utility-navigation--wrapper" ).addClass( "reverse" );
  }

    var c, currentScrollTop = 0,
       navbar = $('#header');

   $(window).scroll(function () {
      var a = $(window).scrollTop();
      var b = navbar.height();
     
      currentScrollTop = a;
     
      if (c < currentScrollTop && a > b + b) {
        navbar.addClass("scrollUp");
      } else if (c > currentScrollTop && !(a <= b)) {
        navbar.removeClass("scrollUp");
      }
      c = currentScrollTop;
  });

     $("#nav-toggle").click(function(){
 
    $("body").toggleClass("menu-toggled");
 
  });


// $(".date--container").html(function(index, html) {
//   return html.replace(/\S/g, '<span>$&</span>');
// });


//
//  Equal height - by Lewi Hussey
//
if ($(window).width() > 1025 ) {

  var matchHeight = (function() {

    return {
  match: function() {
    
    console.log('matching height');

    var groupName = Array.prototype.slice.call(document.querySelectorAll("[data-match-height]"));
    var groupHeights = {};

    for (var item of groupName) {

      var data = item.getAttribute("data-match-height");

      item.style.minHeight = "auto";

      if (groupHeights.hasOwnProperty(data)) {
        Object.defineProperty(groupHeights, data, {
          value: Math.max(groupHeights[data], item.offsetHeight),
          configurable: true,
          writable: true,
          enumerable: true
        });
      } else {
        groupHeights[data] = item.offsetHeight;
      }
    }

    var groupHeightsMax = groupHeights;

    Object.getOwnPropertyNames(groupHeightsMax).forEach(function(value) {

      var elementsToChange = document.querySelectorAll("[data-match-height='" + value + "']");

      for (var i = 0; i < elementsToChange.length; i++) {
        elementsToChange[i].style.height = Object.getOwnPropertyDescriptor(groupHeightsMax, value).value + "px";
      }
    });
  },

  eventListeners: function() {
    window.addEventListener("resize", () => {
      this.match();
    });
  },
    
  init: function() {
    this.eventListeners();
    this.match();
  }
    }
})();

}

document.addEventListener("DOMContentLoaded", function() {
  matchHeight.init();
});


// Custom carousel

var utils = window.fizzyUIUtils;
var Flickity = require('flickity');
require('flickity-bg-lazyload');
require('flickity-fade');

// Header carousel
var flkty = new Flickity( '.featured-slideshow', {
  prevNextButtons: false,
  pageDots: false,
  bgLazyLoad: true,
  wrapAround: true,
  draggable: false,
  autoPlay: false,
  fade: true
});

// Client carousel
var flkty = new Flickity( '.client-slideshow', {
  prevNextButtons: false,
  pageDots: false,
  wrapAround: true,
  draggable: true,
  autoPlay: true,
  lazyLoad: 5,
  imagesLoaded: true,
  groupCells: false,
  autoPlay: 5000,
  pauseAutoPlayOnHover: false,
  freeScroll: true,
  contain: true,
});

}( jQuery ) );
